import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { DownloadAction } from '../../actions/download/DownloadAction';
import CommandStrings from '../Commands.resx';
import { ShowMalwareDetectedAction } from '../../actions/DeferredActions';
import { isReadonlyFacet } from '../../../facets/CommandFacets';

export const downloadCommand: ICommand = {
  key: new Facet('download').id,
  automationId: 'downloadCommand',
  name: CommandStrings.Download,
  action: <ShowMalwareDetectedAction action={ <DownloadAction /> } />,
  iconProps: {
    iconName: 'download'
  },
  facets: {
    ...isReadonlyFacet.pack(true)
  }
};
